export default __webpack_public_path__ + "images/parts-accessories.svg";